<template>
	<div class="footer-bar">
		<div class="container">
			<div class="row">
				<div class="col-lg-4 link">
          福州鑫微创网络科技有限公司<br />
					地址：福州市晋安区盛辉大厦1801室
				</div>
				<div class="col-lg-4 link">
					咨询热线：0591-87520930<br />
					<a href="https://beian.miit.gov.cn" target="_blank">备案信息：闽ICP备2022008251号-1</a><br />
          福州鑫微创网络科技有限公司 <i class="fa fa-copyright"></i> 2016-2025 All
					Right
				</div>
				<div class="col-lg-4">
					<img src="../assets/code.jpg" height="100px" />
				</div>
			</div>
		</div>
		<el-backtop></el-backtop>
	</div>
</template>

<script>
export default {
	name: 'FooterBar',
	components: {},
	data() {
		return {};
	},
	computed: {},
	created() {},
	mounted() {},
	methods: {},
};
</script>
<style lang="scss" scoped>
.footer-bar {
	background: #16172e;
	padding: 3rem 0;
	color: #fff;
	.link {
		border-right: 1px solid #fff;
		min-height: 100px;
		line-height: 1.8rem;
		font-size: 0.86rem;
	}
}
</style>
